import i18next from "src/i18n/config";

export const sourceConfig = {
    workspace: { tooltip: i18next.t("sidepanels:groupPanel.tooltip.workspace"), icon: "fa-folder-tree" },
    parent: { tooltip: i18next.t("sidepanels:groupPanel.tooltip.parentGroup"), icon: "fa-folder-open" },
    group: { tooltip: i18next.t("sidepanels:groupPanel.tooltip.group"), icon: "fa-folder" },
} as const;

type FileSourceKey = keyof typeof sourceConfig;

export const getFileSourceKey = (groupId: API.File["groupId"], selectedGroupId: number | undefined): FileSourceKey => {
    if (groupId === null) {
        return "workspace";
    }
    if (selectedGroupId !== undefined && groupId !== selectedGroupId) {
        return "parent";
    }
    return "group";
};
